module.exports = "https://tutorchat.chegg.com/static/media/ic-upload.cba8654f.svg";